<div class="side-list-actions" *ngIf="numberOfRecords > 0">
  <div class="content-body">
    <div class="mb-2">
      <div class="mb-1 d-flex align-items-center justify-space-between">
        <p class="text-gray-200 fw-bold m-0">Selected Items</p>
        <button
          mat-button
          class="text-gray-300"
          disableRipple
          (click)="cancelSelection()"
        >
          <mat-icon>highlight_off</mat-icon>
        </button>
      </div>
      <div>
        <p class="font-size-18 fw-bold mb-2">
          <span class="text-gray-200 font-size-20">Records:</span>
          {{ numberOfRecords }}
        </p>
        <a class="link" href="javascript:void(0)" (click)="cancelSelection()"
          >Cancel Selections</a
        >
      </div>
    </div>
    <hr class="hr" />
    <div>
      <div>
        <div class="mt-1">
          <p class="font-size-18 fw-bold mb-2">Edit</p>
          <div class="d-flex align-items-center">
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              *ngIf="getModuleId !== moduleEnum.Notes"
              (click)="delete()"
              [disabled]="isViewPermission$ | async"
            >
              <mat-icon>delete_outline</mat-icon>
              <p>Delete</p>
            </button>
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              *ngIf="
                getModuleId !== moduleEnum.Notes &&
                getModuleId !== moduleEnum.CashEntry &&
                getModuleId !== moduleEnum.Receipt &&
                getModuleId !== moduleEnum.Payment &&
                getModuleId !== moduleEnum.BankEntry
              "
              (click)="copy()"
            >
              <mat-icon>content_copy</mat-icon>
              <p>Copy</p>
            </button>
          </div>
        </div>
        <div class="mt-2">
          <p class="font-size-18 fw-bold mb-2">Export</p>
          <div class="d-flex align-items-center">
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              (click)="export(exportFormat.Excel)"
            >
              <mat-icon>border_all</mat-icon>
              <p>Excel</p>
            </button>
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              (click)="export(exportFormat.Csv)"
            >
              <mat-icon fontSet="material-icons-outlined">description</mat-icon>
              <p>CSV</p>
            </button>
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              (click)="export(exportFormat.PDF)"
            >
              <mat-icon fontSet="material-icons-outlined"
                >picture_as_pdf</mat-icon
              >
              <p>PDF</p>
            </button>
          </div>
        </div>
      </div>

      <div>
        <div class="mt-2">
          <p class="font-size-18 fw-bold mb-2">Options</p>
          <div class="d-flex align-items-center">
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              (click)="print()"
            >
              <mat-icon fontSet="material-icons-outlined">print</mat-icon>
              <p>Print</p>
            </button>
            <button
              [disabled]="disableInActiveAction || (isViewPermission$ | async)"
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              *ngIf="getModuleId !== moduleEnum.Notes"
              (click)="archiveAndRestore(true)"
            >
              <mat-icon>archive</mat-icon>
              <p>Inactive</p>
            </button>
            <button
              [disabled]="disableActiveAction || (isViewPermission$ | async)"
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              *ngIf="getModuleId !== moduleEnum.Notes"
              (click)="archiveAndRestore(false)"
            >
              <mat-icon>unarchive</mat-icon>
              <p>Active</p>
            </button>
            <button
              class="button-icon"
              type="button"
              mat-button
              disableRipple
              [disabled]="isViewPermission$ | async"
              (click)="email()"
              *ngIf="
                getModuleId === moduleEnum.Receipt ||
                getModuleId === moduleEnum.Invoices ||
                getModuleId === moduleEnum.CreditNote ||
                getModuleId === moduleEnum.DebitNote ||
                getModuleId === moduleEnum.Quotation
              "
            >
              <mat-icon fontSet="material-icons-outlined">email</mat-icon>
              <p>Email</p>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
